import { useQuery } from "hooks/useQuery";
import { useState } from "react";
import { ProgramsService } from "services/programs";
import LoadingOverlay from "components/blocks/LoadingOverlay";
import { useTranslation } from "react-i18next";
import { LookupService } from "services/lookupService";
import { OperatorFilter } from "services/shared-models/sharedEnums";
import { DataGridRequest } from "services/shared-models/sharedTypes";
import Dropdown from "components/blocks/Dropdown";
import MultiSelectDropdown from "components/blocks/MultiSelectDropdown";
import { useCookieContext } from "contexts";
import ProgramCard from "./ProgramCard";

const ProgramsTaps = () => {
  const { t} = useTranslation("WelcomePage");
  const { isAr } = useCookieContext();

  const [activeProgramTypeId, setActiveProgramTypeId] = useState(-1);
  const [activeAudiencesType, setActiveAudiencesType] = useState<number[]>([]);

  const { data, loading } = useQuery({
    queryFn: async () => {
      const filter: DataGridRequest["filter"] =
        activeProgramTypeId === -1
          ? []
          : [
              {
                field: "ClassificationProgram.ProgramTypeId",
                value: activeProgramTypeId,
                operator: OperatorFilter.equal,
              },
            ];

      if (activeAudiencesType.length) {
        filter.push({ field: "audienceTypes", value: activeAudiencesType, operator: OperatorFilter.contains });
      }

      return await ProgramsService.getAllPublicPrograms({
        pageIndex: 1,
        pageSize: 10,
        filter: filter,
      });
    },
    triggers: [activeProgramTypeId, isAr, ...activeAudiencesType],
  });

  const { data: audienceTypes, loading: audienceTypesLoading } = useQuery({
    queryFn: async () => {
      return await LookupService.getAllAudienceTypes();
    },
    triggers: [isAr],
  });

  const { data: programsTypes, loading: programsTypesLoading } = useQuery({
    queryFn: async () => {
      return await LookupService.getAllProgramTypes();
    },
    triggers: [isAr],
  });

  const programTypeOptions = [
    {
      id: -1,
      value: t("all"),
    },
    ...(programsTypes?.map((programType) => ({
      id: programType.id,
      value: programType.programTypesDetail.displayName,
    })) ?? []),
  ];

  return (
    <div>
      <div className="d-flex gap-2 flex-wrap">
        {loading && <LoadingOverlay visible={programsTypesLoading || audienceTypesLoading} />}
        <Dropdown
          useReactSelect
          label={t("programClassification")}
          data={programTypeOptions}
          value={activeProgramTypeId}
          disabled={loading || programsTypesLoading}
          noSelectionPlaceholder={t("all")}
          onChange={(value) => {
            setActiveProgramTypeId(Number(value));
          }}
          wrapperStyle={{ minWidth: 220 }}
        />

        <MultiSelectDropdown
          label={t("audiencesType")}
          data={audienceTypes?.map((ele) => ({ value: ele.audienceTypeDetail.displayName, id: ele.id })) || []}
          useReactSelect={true}
          onChange={(values) => {
            setActiveAudiencesType(values.map(Number));
          }}
          wrapperStyle={{ minWidth: 220 }}
        />
      </div>

      <div className="d-flex flex-wrap gap-3 mt-2 position-relative flex-row">
        {loading && <LoadingOverlay visible={loading} />}

        {data?.result.map((program) => (
          
        <ProgramCard program={program} />
            
        ))}
       
      </div>
    </div>
  );
};

export default ProgramsTaps;
